import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { SignalRProvider } from "./Contexts/SignalRContext"; // Import SignalRProvider

function App() {
    return (
        <SignalRProvider>
            <Router>
                <AppRoutes />
            </Router>
        </SignalRProvider>
    );
}

export default App;